export default __webpack_public_path__ + "static/char-s-16-en-28f287c5d53023a5c833a9ceec5ab267.webp";